import * as d3 from 'd3'
export default {
  methods: {

    draw_Progress(data, sch) {

      let progress = this.canvasForms
      .append('g')
      .attr('transform', `translate(${sch.x}, ${this.chart.y-100})`)

      let proLen = (270/100) * data.ACT
      progress
      .append('text')
      .attr('transform', `translate(0, -12)`)
      .attr('font-size', 12).attr('fill', '#000')
      .text(sch.code + ' Schedule')

      progress
      .append('text')
      .attr('transform', `translate(0, -2)`)
      .attr('font-size', 9).attr('fill', '#757575')
      .text('Overall Progress')

      progress
      .append('rect')
      .attr('x', 0).attr('y', 35).attr('rx', 7)
      .attr('width', 270).attr('height', 14).attr('fill', '#F4F5F5')

      progress
      .append('rect')
      .attr('x', 0).attr('y', 35).attr('rx', 7)
      .attr('width', proLen).attr('height', 14)
      .attr('fill', `url(#${this.localId}_YellowGreen_H2)`)
      .attr('opacity', .6)

      progress
      .append('text')
      .attr('x', data.ACT< 75 ? proLen + 2 : proLen - 2)
      .attr('y', 42 + 12*0.35)
      .attr('font-size', 12).attr('fill', '#000')
      .attr('text-anchor', data.ACT< 75 ? 'start' : 'end')
      .text(data.ACT.toFixed(1) + '%')

      progress
      .append('text')
      .attr('transform', `translate(0, 70)`)
      .attr('font-size', 11).attr('fill', '#333')
      .text('Discipline')


      // EARLY
      let early = progress
      .append('g')
      .attr('transform', `translate(0, 17)`)
      .attr('font-size', 11)

      early
      .append('text')
      .attr('id', `EARLY_NAME_${this.localId}`)
      .attr('fill', '#757575').text('Early')

      early
      .append('text')
      .attr('id', `EARLY_VAL_${this.localId}`)
      .attr('x', 70).attr('fill', '#757575').attr('text-anchor', 'end')
      .text(data.EP.toFixed(1) + '%')

      early
      .append('text')
      .attr('id', `EARLY_DEL_${this.localId}`)
      .attr('x', 110).attr('fill', this.gmx_deltaValue(data.ED)).attr('text-anchor', 'end')
      .text(data.ED.toFixed(1) + '%')

      // LATE
      let late = progress
      .append('g')
      .attr('transform', `translate(0, 31)`)
      .attr('font-size', 11)

      late
      .append('text')
      .attr('id', `EARLY_NAME_${this.localId}`)
      .attr('fill', '#757575').text('Late')

      late
      .append('text')
      .attr('id', `EARLY_VAL_${this.localId}`)
      .attr('x', 70).attr('fill', '#757575').attr('text-anchor', 'end')
      .text(data.LP.toFixed(1) + '%')

      late
      .append('text')
      .attr('id', `EARLY_DEL_${this.localId}`)
      .attr('x', 110).attr('fill', this.gmx_deltaValue(data.LD)).attr('text-anchor', 'end')
      .text(data.LD.toFixed(1) + '%')



        


    },

  }
}